export function changeProjectVersion() {
  const latestVersion = document.querySelectorAll(".dropdown__item").length + 1;
  const url = new URL(window.location.href);
  url.searchParams.set("version", latestVersion);
  window.history.replaceState(null, null, url.toString());
  const dropdownText = "Version " + latestVersion;
  document.querySelector(".dropdown__selected-item").textContent = dropdownText;
  document.querySelector(
    ".dropdown-content"
  ).innerHTML += `<li class="dropdown__item">${dropdownText}</li>`;
}
